import React from "react";
import { motion } from "framer-motion";
import "./ServicesHero.css";

import research from "../../Assets/research.jpg";
import systems from "../../Assets/systems.jpg";
import community from "../../Assets/community.jpg";

const ServicesHero = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    <section className="services-hero">
      {/* Top Hero Section */}
      <motion.div
        className="services-grid-bg"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <div className="services-hero-content">
          <motion.div className="services-text-block" variants={fadeUp}>
            <h1>
              Services <br /> We Provide
            </h1>
          </motion.div>

          <motion.div className="services-description" variants={fadeUp}>
            <p>
              We provide holistic education consultancy by integrating counseling,
              community outreach, and sustainable development initiatives.
            </p>
          </motion.div>
        </div>
      </motion.div>

      {/* Middle Heading */}
      <motion.div
        className="services-middle"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
      >
        <span className="badge">OUR SERVICES</span>
        <h2>
          Empowering Growth: <br /> From Classroom to Community
        </h2>
      </motion.div>

      {/* Cards Section */}
      <div className="cards-container">
        {[
          {
            img: research,
            title: "Advancing Human Potential Through Research",
            text: `We provide expertise in research for institutions which target policies 
              and programming, strategies, human capacity development, livelihoods, 
              emerging issues, and life and health skills from a multi-disciplinary approach.`,
          },
          {
            img: systems,
            title: "Strategic Systems and Human Capital Solutions",
            text: `We develop training materials targeting human systems for clients in 
              UN bodies, governments, INGOs, CSOs, and Parastatals. We use learner-centered 
              and adult training approaches that motivate active participation.`,
          },
          {
            img: community,
            title: "PeopleCore: From Research to Community Impact",
            text: `Through our CBO Center for People Development (C4PD), we promote 
              community farmer field schools, safe water, hygiene, and income-generating 
              activities to improve lives and foster long-term sustainability.`,
          },
        ].map((card, index) => (
          <motion.div
            key={index}
            className={`card ${index === 1 ? "reverse" : ""}`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
          >
            <img src={card.img} alt={card.title} />
            <div className="card-content">
              <h2>{card.title}</h2>
              <p>{card.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ServicesHero;
